import React from 'react';
import PropTypes from 'prop-types';

import ExternalLinkModal from './ExternalLinkModal';

class ExternalLink extends React.Component {
    static propTypes = {
        children: PropTypes.node.isRequired,
        className: PropTypes.string,
        url: PropTypes.string.isRequired,
        title: PropTypes.string
    };

    static defaultProps = {
        className: ""
    };

    constructor(props) {
        super(props);
        this.state = {
            shouldPresentModal: false
        };
    }

    onClickLink = (e) => {
        e.preventDefault();
        this.setState({
            shouldPresentModal: true
        });
    };

    onModalCancel = () => {
        this.setState({
            shouldPresentModal: false
        });
    };

    onModalContinue = () => {
        // Create a temporary link element that will set `noopener` and `noreferrer`,
        // then manually fire its click handler.
        Object.assign(document.createElement('a'), {
            target: '_blank',
            href: this.props.url,
            rel: 'noopener noreferrer'
        }).click();
        this.setState({
            shouldPresentModal: false
        });
    };

    render() {
        return (
            <span>
                <a
                    className={this.props.className}
                    href={this.props.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={this.onClickLink}
                    aria-label={this.props.title}>
                    {this.props.children}
                </a>
                {
                    this.state.shouldPresentModal &&
                    <ExternalLinkModal
                        shouldPresent
                        onCancel={this.onModalCancel}
                        onContinue={this.onModalContinue} />
                }
            </span>
        );
    }
}

export default ExternalLink;
